import { useEditBrand } from "@entities/brand";
import { useGetBrandById } from "@entities/brand/lib/hooks/useGetBrandById";
import { AggrementUpdateForm } from "@entities/brand/ui/AggrementForm";
import { BrandUpdateForm } from "@entities/brand/ui/BrandUpdateForm";
import { BILLING_TYPE } from "@entities/organisation/lib/constants";
import useGetBrandBillingById from "@entities/organisation/lib/hooks/useGetBrandBillingById";
import BillingInfo from "@entities/organisation/ui/BillingInfo";
import { ToastService } from "@shared/lib/services";
import { IBrand } from "@shared/lib/types";
import { CircularProgress } from "@shared/ui";
import { Modal, Row, Tabs } from "antd";
import { useEffect, useMemo, useState } from "react";
import { BrandCard } from "./BrandCard";
import styles from "./styles.module.scss";

interface BrandProps {
  brandId: string;
  paymentTerms: string[];
  brandOrganisationId: string;
}

export function ManageBrand({
  brandId,
  paymentTerms,
  brandOrganisationId,
}: BrandProps) {
  const { brand, isFetching } = useGetBrandById(brandId);
  // const { assignUsers, isAssigned, isAssigning } = useAssignUsers();
  const { isUpdated, isUpdating, update } = useEditBrand();
  const [isModalVisible, setModalVisible] = useState(false);
  const [isAggrementModalVisible, setAggrementModalVisible] = useState(false);

  const { brandBilling, refetchBrandBilling } = useGetBrandBillingById(
    brandId || ""
  );

  console.log("Getting brand billing: ", brandBilling);

  const [editrandUserModalProps, setEditBrandUserModalProps] = useState<{
    visisble: boolean;
    id?: string;
  }>({ visisble: false, id: "" });

  const selectedBrandUser = useMemo(() => {
    if (editrandUserModalProps.id) {
      return brand?.brandUsers?.find(
        (item) => item.userId === editrandUserModalProps.id
      );
    }
    return undefined;
  }, [editrandUserModalProps.id, brand]);

  const handleSubmit = (brandData: Partial<IBrand>) => {
    update({ brand: brandData, brandId });
  };

  useEffect(() => {
    if (isUpdated) {
      ToastService.success("Brand Updated");
      setModalVisible(false);
      setAggrementModalVisible(false);
    }
  }, [isUpdated]);

  // useEffect(() => {
  //   if (isAssigned) {
  //     ToastService.success("Account Manager Added");
  //     setCreateAdminUserModalVisible(false);
  //   }
  // }, [isAssigned]);

  const items = useMemo(() => {
    if (brand) {
      return [
        {
          label: "Brand Info",
          key: "brandInfo",
          children: (
            <div className={styles.container}>
              <BrandCard
                brand={brand}
                handleEditClick={() => setModalVisible(true)}
              />

              {/* <AggrementCard
                brand={brand}
                handleEditClick={() => setAggrementModalVisible(true)}
              /> */}
            </div>
          ),
        },
        ...(brand?.brandOrganisation?.billingMode === BILLING_TYPE.Multiple &&
        brandOrganisationId
          ? [
              {
                label: "Billing Info",
                key: "billing",
                children: (
                  <BillingInfo
                    billingMode={brand?.brandOrganisation?.billingMode}
                    brandId={brandId}
                    brandOrganisationId={brandOrganisationId}
                    billingDetails={brandBilling?.data}
                    refetch={() => refetchBrandBilling()}
                  />
                ),
              },
            ]
          : []),
        // {
        //   label: "AI Controls",
        //   key: "aiControls",
        //   children: <AIControls brandId={brandId} showTitle={false} />,
        // },
      ];
    }
    return [];
  }, [brand, brandId, brandBilling, brandOrganisationId]);

  if (isFetching) {
    return (
      <Row justify={"center"}>
        <CircularProgress />
      </Row>
    );
  }

  if (!brand) return <></>;

  return (
    <div>
      {/* <Notes
        handleSubmit={(value) => handleSubmit({ note: value })}
        isSubmiting={isUpdating}
        value={brand?.notes?.note || ""}
      /> */}

      <Tabs items={items} />

      {/* <BrandUsers
        brandUsers={brand.brandUsers || []}
        onAddClick={() => setCreateBrandUserModalVisible(true)}
        onTileClick={(user) =>
          setEditBrandUserModalProps({ visisble: true, id: user.userId })
        }
      /> */}
      {/* <AdminUsers
        adminUsers={brand.adminUsers || []}
        onAddClick={() => setCreateAdminUserModalVisible(true)}
      /> */}
      {/* <GuideLines
        guidelines={brand.brandGuidelinesList || []}
        isEnabled={brand.isBrandGuidelines ?? true}
        handleSubmit={(guidelines, enabled) =>
          update({
            brandId: brand._id,
            brand: {
              brandGuidelinesList: guidelines,
              isBrandGuidelines: enabled,
            },
          })
        }
        isSubmitting={isUpdating}
      /> */}
      {/* <div className={styles.card}>
        <Space
          style={{
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
          }}
        >
          <div>
            <div className={styles.permItemTitle}>Disable</div>
            <div className={styles.permItemDesc}>
              Disabled users cannot login
            </div>
          </div>
          <Switch
            checked={brand.status === ACCOUNT_STATUS.INACTIVE}
            onChange={(value) => {
              update({
                brand: {
                  status: value
                    ? ACCOUNT_STATUS.INACTIVE
                    : ACCOUNT_STATUS.ACTIVE,
                },
                brandId,
              });
            }}
            loading={isUpdating}
          />
        </Space>
      </div> */}
      <Modal
        title={"Update Brand"}
        open={isModalVisible}
        onCancel={() => {
          setModalVisible(false);
        }}
        footer={null}
        destroyOnClose
      >
        <BrandUpdateForm
          onSubmit={handleSubmit}
          isSubmitting={isUpdating}
          initialValues={brand}
        />
      </Modal>
      <Modal
        title={"Update Agreement"}
        open={isAggrementModalVisible}
        onCancel={() => {
          setAggrementModalVisible(false);
        }}
        footer={null}
        destroyOnClose
      >
        <AggrementUpdateForm
          onSubmit={handleSubmit}
          isSubmitting={isUpdating}
          initialValues={brand}
          paymentTerms={paymentTerms}
        />
      </Modal>
      {/* <Modal
        title={"Create Brand User"}
        open={createBrandUserModalVisible}
        onCancel={() => {
          setCreateBrandUserModalVisible(false);
        }}
        footer={null}
        destroyOnClose
      >
        <CreateBranndUserForm
          brandId={brandId}
          handleSubmit={() => setCreateBrandUserModalVisible(false)}
        />
      </Modal> */}
      {/* <Modal
        title={"Edit Brand User"}
        open={editrandUserModalProps.visisble}
        onCancel={() => {
          setEditBrandUserModalProps({ visisble: false, id: undefined });
        }}
        footer={null}
        destroyOnClose
      >
        {selectedBrandUser && (
          <ManageBrandUser brandId={brandId} brandUser={selectedBrandUser} />
        )}
      </Modal> */}

      {/* <Modal
        title={"Add Account manager"}
        open={createAdminUserModalVisible}
        onCancel={() => {
          setCreateAdminUserModalVisible(false);
        }}
        footer={null}
        destroyOnClose
      >
        <AddAdminUsers
          alreadyAddedUsers={brand.adminUsers.map((admin) => admin.userId)}
          onSubmit={(value) =>
            assignUsers({ brandId, userId: value, permissions: [] })
          }
          isSubmitting={isAssigning}
        />
      </Modal> */}
    </div>
  );
}
